import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CampaignStepType } from 'projects/Administration/src/app/business-entities/campaign-list-model';
import { CommNotificationModel, CommunicationRoleModel } from 'projects/Administration/src/app/business-entities/notification-details-result-view-model';
import { ManualNotificationRequestModel, ManualNotificationRecipientList, ManualTemplateDetailModel, TemplateLegendRequestModel, TemplateLegendResponseModel } from 'projects/Administration/src/app/business-entities/manual-notification-model';
import { ModuleModel } from 'projects/Administration/src/app/business-entities/module-model';
import { UserTypeModel } from 'projects/Administration/src/app/business-entities/user-type-model';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { DealerDataService } from '../../../../data-services/dealer-data.service';
import { AddRecipientComponent } from './add-recipient/add-recipient.component';
import { MyRecipientComponent } from './my-recipient/my-recipient.component';
import { LanguageService } from 'projects/Administration/src/app/business-services/language.service';
import { CookieService } from 'ngx-cookie-service';
import Quill from 'quill';
import { TemplateScope } from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html'
})
export class SendNotificationComponent implements OnInit {
  @Input() dealerId: string;
  @Input() appointmentId: number;
  @Input() isForApprovalORRejection: number;
  saveButtonEnable = false;
  templateTypeList: any = [];
  templateList: ManualTemplateDetailModel[];
  templateListFiltered: ManualTemplateDetailModel[];
  languageList: any = [];
  notificationUserList: CommunicationRoleModel[];
  moduleList: ModuleModel[];
  moduleListFilterd: ModuleModel[];
  userTypeList: UserTypeModel[];
  userTypeListFilterd:  UserTypeModel[];
  WOnumber: string = '';
  DealerName: string = '';
  channel = CampaignStepType;
  selectedChannel: number = 2;
  selectedLaguage: string;
  selectedModule: number = null;
  selectedUserType: number = null;
  selectedLanguage: string;
  popupCloseResult = false;
  roleOrder = [
    "Customer", 
    "Kunde",
    "Contact", 
    "Kontakt",
    "Admin",
    "Dealers", 
    "Forhandler",
    "Service Advisor",
    "Mechanics",
    "Mekaniker",
];
  @ViewChild("addButton") addBtn: ElementRef;
  EditManualNotificationForm: CommNotificationModel = {
    templateId: 0,
    templateTypeId: 0,
    body: '',
    subject: '',
    notificationUserList: []
  };
  templateLegendResponseModel: TemplateLegendResponseModel = { item1: '', item2: '' }
  sendNotificationModel: ManualNotificationRequestModel = {
    actionCode: 0,
    templateCode: 0,
    applicationId: 0,
    templateType: 0,
    subject: '',
    body: '',
    loginUserId: '',
    roleId:0,
    dealerId: '',
    appointmentId: 0,
    appointmentGuid: '',
    mechanicId: 0,
    archiveAppointmentId: 0,
    customerId: 0,
    isAddNotification: false,
    languageCode: '',
    cultureCode: '',
    isBasic: false,
    workOrderNo: '',
    recipientList: []
  };
  quill: Quill;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };
  constructor(
    private activeModal: NgbActiveModal,
    private model: NgbModal,
    private cdf: ChangeDetectorRef,
    private service: DealerDataService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private currentLanguageService: CurrentLanguage,
    public workOrderService: AppointmentWorkOrderService,
    public editAppointmentService: EditAppointmentService,
    private modalService: NgbModal,
    private languageService: LanguageService,
    private cookieservice: CookieService
    //private router: Router
  ) { }

  ngOnInit(): void {
    this.currentLanguageService.currentLanguage.subscribe((res) => {
      this.selectedLanguage = res;
    })
    if (this.editAppointmentService.appointmentDetails) {
      this.WOnumber = this.editAppointmentService.appointmentDetails.workOrderNo;
      this.DealerName = this.editAppointmentService.appointmentDetails.dealerName;
      if (this.WOnumber && this.WOnumber.length > 0) {
        this.WOnumber = '#' + this.WOnumber;
      }
      this.cdf.detectChanges()
    }
    this.initialize();
  }

  initialize() {
    this.getManualNotificationData();
    this.getLangugage();
  }

  async getLangugage() {
    await this.languageService.getAllLanguage().then(result => {
      this.languageList = result;
    });
    this.selectedLaguage = this.cookieservice.get('userSelectedLanguage').length > 0 ? this.cookieservice.get('userSelectedLanguage') : this.selectedLaguage;
  }

  getFlagImage(flag: string) {
    let uri = "assets/images/countryflags/"
    if (flag != undefined)
      return uri + flag;
  }

  OpenAddRecipientModel(): void {
    const modalref = this.model.open(AddRecipientComponent, { size: 'lg' });
    modalref.result.then((response) => {
      if (response.success) {
        this.getManualNotificationData();
      }
    });
  }

  OpenMyRecipientModel(): void {
    const modalref = this.model.open(MyRecipientComponent, { size: 'lg' });
    modalref.result.then((response) => {
      if (response.success) {
        this.getManualNotificationData();
      }
    });
  }
  onTemplateChange(templateId: number) {
    if (templateId != -1) {
      let item = this.templateList.find(x => x.id == templateId);
      if (item) {
        this.EditManualNotificationForm.body = item.body;
        this.EditManualNotificationForm.subject = item.subject;
        this.EditManualNotificationForm.actionTypeId = item.actionTypeCode;
        this.EditManualNotificationForm.templateId = item.id;
        this.EditManualNotificationForm.templateTypeId = item.templateType;
      }
      else {
        this.EditManualNotificationForm.body = "";
        this.EditManualNotificationForm.subject = "";
      }
    }
    else {
      this.EditManualNotificationForm.body = "";
      this.EditManualNotificationForm.subject = "";
    }
    this.ValidateFields();
  }
  async getManualNotificationData() {
    this.spinner.show();
    this.templateList = [];
    this.templateTypeList = [];
    this.notificationUserList = [];
    this.moduleList = [];
    this.userTypeList = [];
    this.templateListFiltered = [];
    const requestModel = {
      AppointmentId: this.appointmentId,
      DealerId: this.dealerId,
      IsForApprovalOrRejection: this.isForApprovalORRejection,
      LanguageCode: this.selectedLanguage,
      TemplateScope: TemplateScope.Appointment
    }
    await this.service.getManualNotificationData(requestModel).then(result => {
      if (result?.responseObject) {
          this.templateList = result.responseObject.templateList;
          this.templateTypeList = result.responseObject.templateTypeList;
          if (this.editAppointmentService.appointmentDetails.isFromArchive) {
            this.templateTypeList = this.templateTypeList.filter(
              x => x.text?.toLowerCase() === 'sms'
            );
          }
          this.notificationUserList = result.responseObject.notificationUserList;
          this.moduleList = result.responseObject.moduleList;
          this.userTypeList = result.responseObject.userTypeList;
          if (this.templateTypeList && this.templateTypeList.length > 0) {
            this.EditManualNotificationForm.templateTypeIds = +this.selectedChannel;
            this.templateListFiltered = this.templateList.filter(x=>x.templateType == this.selectedChannel);
          }
          if (this.templateListFiltered && this.templateListFiltered.length > 0) {
            let item = this.templateListFiltered[0];
            this.EditManualNotificationForm.body = item.body;
            this.EditManualNotificationForm.subject = item.subject;
            this.EditManualNotificationForm.actionTypeId = item.actionTypeCode;
            this.EditManualNotificationForm.templateId = item.id;
            this.EditManualNotificationForm.templateTypeId = item.templateType;
          }
          this.ValidateNotificationUserList();
        this.ValidateFields();
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      }).finally(() => {
        this.spinner.hide();
      });
  }
  getUserTypeName(userTypeId) {
    return this.userTypeList?.find(x => x.id == userTypeId)?.name ?? "";
  }
  getSectionName(templateId){
    return this.moduleList?.find(x=>x.id == templateId)?.name ?? "";
  }
  OnClose() {
    this.activeModal.close({ success: false })
  }
  onLanguageChange()
  {
    this.selectedLanguage = this.selectedLaguage;
    this.getManualNotificationData();
  }
   onFilter() {
    this.moduleListFilterd = this.moduleList;
    this.userTypeListFilterd = this.userTypeList;
    this.selectedModule = null;
    this.selectedUserType = null;
    this.EditManualNotificationForm.templateTypeIds = this.selectedChannel;
    this.templateListFiltered = this.templateList.filter(x => x.templateType == this.selectedChannel);
    if(this.selectedChannel == 3){
      this.moduleListFilterd = this.moduleList.filter(x=> x.id == 5);
      this.userTypeListFilterd = this.userTypeList.filter(x=> x.id == 5);
      this.selectedModule = this.moduleListFilterd.filter(x=> x.id == 5)[0]?.id;
      this.selectedUserType = this.userTypeListFilterd.filter(x=> x.id == 5)[0]?.id;
      this.applyTemplateFilters();
    }
    this.ValidateNotificationUserList();
  }

  applyTemplateFilters() {
    this.templateListFiltered = this.templateList.filter(x => x.templateType == this.selectedChannel);
    
    if (this.selectedModule !== null && this.selectedModule !== undefined) {
      this.templateListFiltered = this.templateListFiltered.filter(x => x.applicationId == this.selectedModule);
    }
    
    if (this.selectedUserType !== null && this.selectedUserType !== undefined) {
      this.templateListFiltered = this.templateListFiltered.filter(x => x.userTypeId == this.selectedUserType);
    }
    
    this.onTemplateChange(this.templateListFiltered[0]?.id);
  }

  onModuleChange() {
    this.applyTemplateFilters();
  }

  onUserTypeChange() {
    this.applyTemplateFilters();
  }
  ValidateFields() {
    if (this.EditManualNotificationForm.templateTypeIds == this.channel.SMS && !this.EditManualNotificationForm.body) {
      this.saveButtonEnable = false;
    }
    else if (this.EditManualNotificationForm.templateTypeIds != this.channel.SMS &&
      (!this.EditManualNotificationForm.body || !this.EditManualNotificationForm.subject)) {
      this.saveButtonEnable = false;
    }
    else {
      this.saveButtonEnable = true;
    }
  }
  ValidateNotificationUserList() {
    const templateTypeId = this.EditManualNotificationForm.templateTypeIds;
  
  if (!this.notificationUserList || this.notificationUserList.length === 0) {
    return;
  }

  this.notificationUserList.forEach((list) => {
    if (templateTypeId == this.channel.Email) {
      list.isDisabled = !list.email;
      if (!list.email) {
        list.isSelected = false;
      }
    } else if (templateTypeId == this.channel.SMS) {
      list.isDisabled = !(+list.mobile > 0 && +list.mobileCode > 0);
      if (!list.mobile || !list.mobileCode) {
        list.isSelected = false;
      }
    } else if (templateTypeId == this.channel.PushNotification) {
      list.isDisabled = (list.userTypeId != 5);
      if(list.userTypeId != 5){
        list.isSelected = false;
      }
      if((this.notificationUserList.filter(x =>x.userTypeId == 5).length == 1) && list.userTypeId == 5){
        list.isSelected = true;
      }
    }
  });

  this.cdf.detectChanges();
  this.ValidateFields();
  }
  
  SendNotification() {
    let selectedList = this.notificationUserList.filter(x => x.isSelected === true);
    if (selectedList && selectedList.length > 0) {
      this.sendNotificationModel = {
        body: this.EditManualNotificationForm.body,
        subject: this.EditManualNotificationForm.subject,
        templateCode: this.EditManualNotificationForm.templateId,
        templateType: this.EditManualNotificationForm.templateTypeIds,
        actionCode: this.EditManualNotificationForm.actionTypeId,
        dealerId: this.editAppointmentService.appointmentDetails.dealerId,
        languageCode: this.selectedLanguage,
        appointmentId: this.editAppointmentService.appointmentDetails.isFromArchive ? 0 : this.editAppointmentService.appointmentDetails.id,
        archiveAppointmentId: this.editAppointmentService.appointmentDetails.isFromArchive ? this.editAppointmentService.appointmentDetails.id : 0,
        appointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
        applicationId: 0,
        cultureCode: '',
        customerId: 0,
        isAddNotification: false,
        loginUserId: '',
        roleId:0,
        mechanicId: 0,
        isBasic: false,
        workOrderNo:this.editAppointmentService.appointmentDetails.workOrderNo,
        recipientList: []
      }
      selectedList.forEach(rec => {
        let recipient: ManualNotificationRecipientList = {
          fromEmail: '',
          toEmail: rec.email,
          userId: rec.userId,
          deviceId: rec.deviceId,
          fromMobileCode: '',
          fromMobileNo: '',
          toMobileCode: rec.mobileCode,
          toMobileNo: rec.mobile
        }
        this.sendNotificationModel.recipientList.push(recipient);
      });
      this.spinner.show();
      this.service.SendNotification(this.sendNotificationModel).then((res) => {
        if (res.responseObject === true) {
          let msg = this.translate.instant("lblNotificationSend");
          this.toaster.success(msg);
          this.activeModal.close({ success: true });
        }
        else {
          let msg = this.translate.instant("lblNotificationSendFailedMsg");
          this.toaster.error(msg);
        }
      }).finally(() => {
        this.spinner.hide()
      });
    }
    else{
      this.toaster.error(this.translate.instant("lblSelectUser"))
    }
  }
  NotificationPreview(viewContent) {
    let requestModel:TemplateLegendRequestModel={appointmentId:0,archiveAppointmentId:0,createdBy:'',cultureCode:'',customerId:0,dealerId:'',languageCode:'',mechanicId:0,templateId:0,templateType:0,subject:'',body:''};
    requestModel.appointmentId = this.editAppointmentService.appointmentDetails.isFromArchive ? 0 : this.editAppointmentService.appointmentDetails.appointmentId;
    requestModel.archiveAppointmentId = this.editAppointmentService.appointmentDetails.isFromArchive ? this.editAppointmentService.appointmentDetails.appointmentId : 0;
    requestModel.customerId = 0;
    requestModel.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    requestModel.languageCode = this.selectedLanguage;
    requestModel.mechanicId = 0;
    requestModel.templateId = this.EditManualNotificationForm.templateId;
    requestModel.templateType = this.EditManualNotificationForm.templateTypeIds;
    requestModel.body = this.EditManualNotificationForm.body;
    requestModel.subject = this.EditManualNotificationForm.templateTypeIds == this.channel.SMS ? 'SMS' : this.EditManualNotificationForm.subject;
    this.service.getNotificationPreview(requestModel).then((res) => {
      this.templateLegendResponseModel = res.responseObject;
      this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          // this is intentionally
        }
      });
    }).finally(() => {
      this.spinner.hide()
    });

  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}
